<template>
  <div
    class="mx-auto d-flex align-items-center justify-content-center position-relative star-wrapper"
    title="Points"
  >
    <i
      class="bi bi-star-fill position-absolute bi-2x star-icon"
      :class="[`text-${color}`]"
    ></i>

    <span class="position-relative text-dark fw-bold points">
      {{ points }}
    </span>
  </div>
</template>

<script>
export default {
  name: "StarIcon",
  props: {
    points: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      default: "warning"
    }
  }
};
</script>

<style scoped>
.star-wrapper {
  width: 2.5rem;
  height: 2.5rem;
}

.star-icon {
  font-size: 6rem;
  line-height: 1;
  transform: translateX(-2px);
  opacity: 1;
}

.points {
  font-size: 2.6rem;
  transform: translate(-2px, 1.5px);
}
</style>
